// extracted by mini-css-extract-plugin
module.exports = {"image-media__content":"ImageMedia_image-media__content__1GSNM"};